module.exports = __webpack_public_path__ + "img/ycg_login.9bf500ef.svg";